import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

const clientId = '701a7cab-59d3-4e9a-9098-48c0a58447f3';
const tenantId = '752b8092-f529-4eff-a6e8-179e3309ec1e';

const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const apiScope = `api://${clientId}/access_as_user`;

export const loginRequest = {
  scopes: [apiScope],
};

export const msalInstance = new PublicClientApplication(msalConfig);

let initPromise = null;

/**
 * Initialize MSAL and handle any redirect responses.
 * Safe to call concurrently — subsequent callers wait on the same promise.
 */
export function initializeMsal() {
  if (!initPromise) {
    initPromise = (async () => {
      await msalInstance.initialize();
      const response = await msalInstance.handleRedirectPromise();
      if (response) {
        msalInstance.setActiveAccount(response.account);
      } else {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
      }
    })();
  }
  return initPromise;
}
